const CRYPTO_COMMAND_PKG = {
    navTitle: "Crypto",
    routerName: "CryptoDocs",
    commandsDescription: "Large Orders, Bitrex Exchange, USD/BTC, ETH, etc...",

    commandList : [
        {
            title: "Recent Crypto Prints",
            routerRef: "cryptoprints",
            commandString: "!cprint <Coin>",
            description: "Get the 15 latest Trades based on the coin used - " +
                "Currently following BTC - 150k+, ETH-SOL 75k+, DOGE - SHIB - DOT - LTC - XRP 50k+",
            parameters: [
                { name: "Coin: ", desc: "The symbol/ticker of the coin you want" },
            ],
            examples: [
                "!cryptoprints btc",
                "!cprints ltc"
            ],
            type: "Crypto",
            shortcuts: ["cprint"]
        },
        {
            title: "Large Crypto Prints",
            routerRef: "bigcryptoprints",
            commandString: "!bcprint <Coin>",
            description: "Get the 15 latest Trades based on the coin used - Currently following BTC - 150k+, ETH-SOL 75k+, DOGE - SHIB - DOT - LTC - XRP 50k+",
            parameters: [
                { name: "Coin: ", desc: "The symbol/ticker of the coin you want" },
            ],
            examples: [
                "!bigcryptoprints btc",
                "!bcprints btc"
            ],
            type: "Crypto",
            shortcuts: ["bcprint"]
        },
        {
            title: "Crypto Tracker",
            routerRef: "cryptoTracker",
            commandString: "!ctracker",
            description: "Get the current list of tracked coins",
            parameters: ["none"],
            examples: [
                "!ctracker",
            ],
            type: "Crypto",
            shortcuts: ["ctracker"]
        },
        {
            title: "Bittrex Exchange Price",
            routerRef: "bittrex",
            commandString: "!bittrex <Coin>",
            description: "Get latest price from Bittrex exchange for crpyto currency symbol",
            parameters: [
                { name: "Coin: ", desc: "The symbol/ticker of the coin you want the price of " },
            ],
            examples: [
                "!bittrex btc",
                "!bittrex ltc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "GDAX Exchange Price",
            routerRef: "gdax",
            commandString: "!gdax <Coin>",
            description: "Get latest price from gdax for LTC, ETH, BTC",
            parameters: [
                { name: "Coin: ", desc: "The symbol/ticker of the coin you want the price of " },
            ],
            examples: [
                "!gdax btc",
                "!gdax ltc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Polo Exchange Price",
            routerRef: "polo",
            commandString: "!polo <Coin>",
            description: "Get latest price from Poloniex exchange for BTC, ETH, LTC, XRP, ETC, DASH, NXT, ZEC, XMR, STR, REP",
            parameters: [
                { name: "Coin: ", desc: "The symbol/ticker of the coin you want the price of " },
            ],
            examples: [
                "!polo BTC",
                "!polo LTC"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "USD/BitCoinCash Chart",
            routerRef: "chart_bch",
            commandString: "!chart_bch",
            description: "5m USD/BitCoinCash Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_bch"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "USD/Bitcoin Chart",
            routerRef: "chart_btc",
            commandString: "!chart_btc",
            description: " 5m USD/Bitcoin Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_btc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "USD/Ethereum Chart",
            routerRef: "chart_eth",
            commandString: "!chart_eth",
            description: "5m USD/Ethereum Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_eth"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "USD/Litecoin Chart",
            routerRef: "chart_ltc",
            commandString: "!chart_ltc",
            description: "5m USD/Litecoin Forex Chart",
            parameters: ["none"],
            examples: [
                "!chart_ltc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Bitcoin",
            routerRef: "btc",
            commandString: "!btc",
            description: "btc price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!btc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Dash",
            routerRef: "dash",
            commandString: "!dash",
            description: "dash price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!dash"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "ETC",
            routerRef: "etc",
            commandString: "!etc",
            description: "etc price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!etc"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "ETH",
            routerRef: "eth",
            commandString: "!eth",
            description: "eth price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!eth"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Lite",
            routerRef: "lite",
            commandString: "!lite",
            description: "lite price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!lite"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Nem",
            routerRef: "nem",
            commandString: "!nem",
            description: "nem price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!nem"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Ripple",
            routerRef: "ripple",
            commandString: "!ripple",
            description: "ripple price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!ripple"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Strat",
            routerRef: "strat",
            commandString: "!strat",
            description: "strat price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!strat"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
        {
            title: "Ven",
            routerRef: "ven",
            commandString: "!ven",
            description: "VeChain price from Bitcoin Wisdom",
            parameters: ["none"],
            examples: [
                "!ven"
            ],
            type: "Crypto",
            shortcuts: ["none"]
        },
    ]
}

// eslint-disable-next-line no-unused-vars


export {CRYPTO_COMMAND_PKG};